import React from "react";
import { Client } from "@/lib/types/database";
import { ClientContactInfo } from "./ClientDetails/sections/ClientContactInfo";
import { ClientContractInfo } from "./ClientDetails/sections/ClientContractInfo";
import { ClientAddressInfo } from "./ClientDetails/sections/ClientAddressInfo";
import { ClientOtherInfo } from "./ClientDetails/sections/ClientOtherInfo";
import { ClientContractProposals } from "./ClientDetails/sections/ClientContractProposals";

interface ClientInfoDisplayProps {
  client: Client;
  sections?: ("contact" | "contract" | "address" | "other" | "contract-proposals")[];
  variant?: "default" | "compact";
  showTitles?: boolean;
  className?: string;
}

export const ClientInfoDisplay: React.FC<ClientInfoDisplayProps> = ({
  client,
  sections = ["contact", "contract", "address", "other"],
  variant = "default",
  showTitles = true,
  className = "",
}) => {
  const isCompact = variant === "compact";

  const renderSection = (section: string) => {
    switch (section) {
      case "contact":
        return (
          <ClientContactInfo
            key="contact"
            client={client}
            variant={variant}
            showTitle={showTitles}
          />
        );
      case "contract":
        return (
          <ClientContractInfo
            key="contract"
            client={client}
            variant={variant}
            showTitle={showTitles}
          />
        );
      case "address":
        return (
          <ClientAddressInfo
            key="address"
            client={client}
            variant={variant}
            showTitle={showTitles}
          />
        );
      case "other":
        return (
          <ClientOtherInfo key="other" client={client} variant={variant} showTitle={showTitles} />
        );
      case "contract-proposals":
        return (
          <ClientContractProposals
            key="contract-proposals"
            client={client}
            variant={variant}
            showTitle={showTitles}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={`grid grid-cols-1 ${isCompact ? "gap-4" : "gap-6"} ${className}`}>
      {sections.map(renderSection)}
    </div>
  );
};
